import { render, staticRenderFns } from "./PlatformHotspotListAdd.vue?vue&type=template&id=e6f4abf8&scoped=true&"
import script from "./PlatformHotspotListAdd.vue?vue&type=script&lang=js&"
export * from "./PlatformHotspotListAdd.vue?vue&type=script&lang=js&"
import style0 from "./PlatformHotspotListAdd.vue?vue&type=style&index=0&id=e6f4abf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f4abf8",
  null
  
)

export default component.exports